import declare from  "dojo/_base/declare";
import NewFoodSourceSamples from "./NewFoodSourceSamples";

const NewSupplierRequestFoodSamples = declare(NewFoodSourceSamples, {
	/**
	 * @override
	 * initialize samples form with SupplierRequest
	 */
	onCreatePopup: function(view) {
		view.setSupplierRequest(this.widget.getViewNode());
	},

	/**
	 * @override
	 */
	postProcessSuccess: function() {
		if (this.samples?.length <= this.widget.querySize) {
			this._newPostProcess();
		} else {
			this.widget.refreshData();
		}
	},
});

export = NewSupplierRequestFoodSamples;